function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
function buildStyle(_, param) {
    var readingDirection = param.readingDirection;
    return {
        base: _objectSpread({}, readingDirection, {
            flex: '0 0 30%',
            maxHeight: '3rem',
            display: 'flex',
            alignItems: 'center',
            '& > *, & > button': {
                margin: '0.5rem'
            }
        }),
        stacked: {
            flexDirection: 'column-reverse'
        },
        small: {
            position: 'relative',
            right: '0',
            minHeight: '100%'
        }
    };
}
export var useStyle = function(isRtl, isStacked, position) {
    var ref;
    var ref1 = (ref = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    })) !== null && ref !== void 0 ? ref : {
        base: {},
        stacked: {},
        small: {}
    }, base = ref1.base, stacked = ref1.stacked, small = ref1.small;
    return {
        baseContainerStyles: _objectSpread({}, base, isStacked && stacked, {
            justifyContent: position
        }),
        smallContainerStyles: small
    };
};
